<!--
Announcement - display some banner message here (from stt_applcnt_banner for a specified category)
@author cm359n
-->

<template>
  <div id="contain" class="container" >
    <div class="announce-content" v-bind:key="index" v-for="(announcement, index) in announcements" v-html="announcement" />
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Announcement',
  props: {
    category: String,
    getTitle: Boolean,
    getExpiry: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
  },
  data () {
    return {
      dispCategory: this.category,
      title: '',
      expiry: '',
      announcements: []
    }
  },

  mounted () {
    this.fetchAnnouncement()
  },
  methods: {
    fetchAnnouncement () {
      axios.get('/timetable/banners/category/' + this.dispCategory, {})
        .then(response => {
          // take one banner and display it
          let banners = response.data.banners
          if (typeof banners !== 'undefined' && banners.length > 0) {
            this.announcements = []
            banners.map((b) => {
              this.announcements.push(b.content)
              this.title = b.title
              this.expiry = b.expiryTime
            })
            if (this.getTitle) {
              this.$emit('gotTitle', this.title)
            }
            if (this.getExpiry) {
              this.$emit('gotExpiry', this.expiry)
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style>
.announce-content {
  margin-bottom: 6px;
  overflow-wrap: anywhere;
}
</style>
